export const formatDateTime = (value: string | null) =>
  value
    ? new Intl.DateTimeFormat("fi-FI", {
        dateStyle: "short",
        timeStyle: "short"
      }).format(new Date(value))
    : "–";

export const formatMoney = (value: number | null) =>
  value === null
    ? "–"
    : new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR" }).format(value);

